import { AfterViewInit, ChangeDetectorRef, Component, Inject, OnInit, Renderer2 } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';  // Importar el servicio Router
import { MessageDialog } from '../../../components/message-dialog/messageDialog';
import { ListFormBase } from '../../../core/helper/ListFormBase';
import { AppEmpresasService } from '../../../core/services/appEmpresasService.service';
import { AppEmpresas } from '../../../core/models/appEmpresas.model';
import { MatDialog } from '@angular/material/dialog';
import { DOCUMENT } from '@angular/common';
import { ConfigMarcajesDialog } from '../config-marcajes-dialog/config-marcajes-dialog.component';
import { LivesSessionHelper } from '../../../core/helper/livesSessionHelper';

@Component({
  selector: 'app-config-marcajes-list',
  templateUrl: './config-marcajes-list.component.html',
  styleUrls: ['./config-marcajes-list.component.scss'],
  providers: [MessageDialog] // Asegurarte de que el servicio esté disponible
})
export class ConfigMarcajesListComponent extends ListFormBase<AppEmpresas> implements AfterViewInit {

  constructor(
    protected _modelService: AppEmpresasService,
    protected _router: Router,
    protected _route: ActivatedRoute,
    protected _messageDialog: MessageDialog,
    protected _configMarcajesDialog: MatDialog,
    private cdr: ChangeDetectorRef,
    @Inject(DOCUMENT) private document: Document,
    private renderer: Renderer2 ,
    private _livesSession: LivesSessionHelper

  ) {
    super(_modelService, _router, _route, _messageDialog, AppEmpresas);
    this.isCrud = true;
  }

  panelIcon = 'business-time';
  panelTitle = 'Configuración marcajes';
  panelDescription = 'Listado de centros por empresa';
  environmentID = this._livesSession.EnvironmentId;


  ngAfterViewInit(): void {
    this.dataGrid.instance.beginCustomLoading('');
    this.loadData();
  }

  async loadData(): Promise<void> {
    try {
      // Inicia el indicador de carga

      if (this.dataGrid?.instance) {
        this.dataGrid.instance.beginCustomLoading('');
      }

      this._modelService.getAllModelsByEnvironment(this.environmentID).subscribe(
        (companies) => {
          this.dataSource = companies
          this.dataGrid.instance.endCustomLoading();
        },
        (error) => {
          // Manejo de errores
          console.error(error);
        }
      );
    } catch (error) {
      console.error('Error al cargar los datos:', error);
    }
  }

  onClickEdit(e) {
    const dialogRef = this._configMarcajesDialog.open(ConfigMarcajesDialog, {
      width: '100%',
      data: e,
    });

    const dialogContainer = this.document.querySelector('.mat-dialog-container');
    if (dialogContainer) {
      this.renderer.setStyle(dialogContainer, 'background-color', '#dadada');
    }

    dialogRef.afterClosed().subscribe(result => {
      this.loadData();
    });
  }


}
